import React from 'react'
import { string } from 'prop-types'

const MapMarker = props => (
  <svg height={24} viewBox="0 0 20 24" width={20} {...props}>
    <g fill={props.fill} fillRule="evenodd">
      <path d="M10 0C4.477 0 0 4.477 0 10a9.964 9.964 0 002.914 7.055v.001l6.364 6.636c.188.196.451.308.722.308s.534-.112.722-.308l6.364-6.636v-.001A9.964 9.964 0 0020 10c0-5.523-4.477-10-10-10m0 2c4.411 0 8 3.589 8 8 0 2.129-.828 4.134-2.357 5.671L10 21.555l-5.668-5.911A7.946 7.946 0 012 10c0-4.411 3.589-8 8-8" />
      <path d="M10 6a4 4 0 100 8 4 4 0 000-8m0 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2" />
    </g>
  </svg>
)

MapMarker.propTypes = {
  fill: string,
}

MapMarker.defaultProps = {
  fill: '#0fc3c4',
}

export default MapMarker
